import React, {Component} from 'react';
import styled from 'react-emotion';
import {
  Button,
  Typography,
} from 'material-ui';

import { GradientButton } from './GradientButton';

import { scrollTo } from "../lib/scroll";

import hands from '../assets/images/hand.svg';
import handsAlt from '../assets/images/hand2.svg';

import { MOBILE_WIDTH } from '../lib/constants';

const Container = styled('div')`
  min-height: 100vh;
`;

const Centered = styled('div')`
  width: 100%;
  padding-top: 30vh;
  text-align: center;
`;

const ButtonRow = styled('div')`
  width: 60%;
  margin: 2rem auto;
  display: flex;
  align-items: center;
  justify-content: space-around;

  @media all and (min-width: ${MOBILE_WIDTH}px) {
    width: 30%;
  }

`;

const TopImage = styled('img')`
  position: fixed;
  top: -5px;
  width: 35vw;
`;

const BottomImage = styled('img')`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 35vw;
`;

const Header = () => (
  <Centered>
    <Typography type="display4">
      Argo
    </Typography>
    <Typography type="display1">
      Meet Someone New
    </Typography>
  </Centered>
)

const Buttons = () => (
  <ButtonRow>
      <Button
        color="primary"
        onClick={scrollTo('about')}>
        Learn More
      </Button>
      <GradientButton
        raised
        color="accent"
        onClick={scrollTo('download')}>
        Let's Go!
      </GradientButton>
    </ButtonRow>
);

export class Home extends Component {
  constructor() {
    super();
    this.state = {
      opacity: 1,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (event) => {
    const fadePoint = 200;
    const scrollPoint = document.documentElement.scrollTop || document.body.scrollTop;
    const scrolled = scrollPoint < fadePoint ? scrollPoint : fadePoint;
    const opacity = 1 - (scrolled / fadePoint);

    this.setState({
      opacity,
    })
  }

  render() {
    return (
      <Container>
        <Header />
        <TopImage style={{opacity: this.state.opacity}} src={hands} alt="Hands with Coffee" />
        <BottomImage style={{opacity: this.state.opacity}} src={handsAlt} alt="Hands with Coffee" />
        <Buttons />
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.jsx